import documentDataReducer from './reducers'
export { default as documentDataActionTypes } from './types'
export { default as documentDataActions } from './actions'
export default documentDataReducer
